import axios from "axios"

export const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:3001/api";

export const api = axios.create({
  baseURL: apiUrl,
  withCredentials: true
})
